/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CriteriaForRouteResponse
 */
export interface CriteriaForRouteResponse {
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteResponse
     */
    arrivalCityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteResponse
     */
    arrivalCountryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteResponse
     */
    arrivalRegionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteResponse
     */
    arrivalStationCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteResponse
     */
    departureCityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteResponse
     */
    departureCountryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteResponse
     */
    departureRegionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteResponse
     */
    departureStationCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForRouteResponse
     */
    exclude?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForRouteResponse
     */
    isOutbound?: boolean | null;
}

export function CriteriaForRouteResponseFromJSON(json: any): CriteriaForRouteResponse {
    return CriteriaForRouteResponseFromJSONTyped(json, false);
}

export function CriteriaForRouteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForRouteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'arrivalCityCode': !exists(json, 'arrivalCityCode') ? undefined : json['arrivalCityCode'],
        'arrivalCountryCode': !exists(json, 'arrivalCountryCode') ? undefined : json['arrivalCountryCode'],
        'arrivalRegionCode': !exists(json, 'arrivalRegionCode') ? undefined : json['arrivalRegionCode'],
        'arrivalStationCode': !exists(json, 'arrivalStationCode') ? undefined : json['arrivalStationCode'],
        'departureCityCode': !exists(json, 'departureCityCode') ? undefined : json['departureCityCode'],
        'departureCountryCode': !exists(json, 'departureCountryCode') ? undefined : json['departureCountryCode'],
        'departureRegionCode': !exists(json, 'departureRegionCode') ? undefined : json['departureRegionCode'],
        'departureStationCode': !exists(json, 'departureStationCode') ? undefined : json['departureStationCode'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'isOutbound': !exists(json, 'isOutbound') ? undefined : json['isOutbound'],
    };
}

export function CriteriaForRouteResponseToJSON(value?: CriteriaForRouteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'arrivalCityCode': value.arrivalCityCode,
        'arrivalCountryCode': value.arrivalCountryCode,
        'arrivalRegionCode': value.arrivalRegionCode,
        'arrivalStationCode': value.arrivalStationCode,
        'departureCityCode': value.departureCityCode,
        'departureCountryCode': value.departureCountryCode,
        'departureRegionCode': value.departureRegionCode,
        'departureStationCode': value.departureStationCode,
        'exclude': value.exclude,
        'isOutbound': value.isOutbound,
    };
}


